/**
 * Parses a date in ISO format (YYYY-MM-DD) into a Date object
 * without applying UTC timezone offset.
 *
 * @param {string} dateString - Date in YYYY-MM-DD format
 * @returns {Date} - Date object (or current date if the string is empty/invalid)
 */
export function parseISODate(dateString) {
    if (!dateString) return new Date();
    const parts = dateString.split('-');
    if (parts.length !== 3) return new Date();
    return new Date(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2]));
}

/**
 * Returns the local date in "YYYY-MM-DD" format
 * without applying UTC timezone offset.
 *
 * @param {Date} [date=new Date()] - The date to format (default: now)
 * @returns {string} - The local date in YYYY-MM-DD format
 */
export function getLocalDateString(date = new Date()) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}
/**
 * Returns the local time in "HH:MM:SS" format
 * without applying UTC timezone offset.
 *
 * @param {Date} [date=new Date()] - The date from which to extract the time
 * @returns {string} - The local time in HH:MM:SS format
 */
export function getLocalTimeString(date = new Date()) {
    return date.toTimeString().substring(0, 8);
}

/**
 * Returns the local datetime in "YYYY-MM-DDTHH:MM" format
 * without applying UTC timezone offset.
 *
 * @param {Date} [date=new Date()] - The date to format (default: now)
 * @returns {string} - The local datetime in YYYY-MM-DDTHH:MM format
 */
export function getLocalDateTime(date = new Date()) {
    return `${getLocalDateString(date)}T${getLocalTimeString(date).substring(0, 5)}`;
}